module.exports = __webpack_public_path__ + "img/地图B-维州国立美术馆.4ddb4acc.png";